export default __webpack_public_path__ + "static/media/zw.72494003.svg";